module.exports = __webpack_public_path__ + "img/D201801_4.68daefbd.jpg";